import mixins from "../../mixins";

const generateUID = mixins.generateUID.methods.generateUID;

export default {
  isEditMode: true,
  pageProperties: {
    "pages": [
      {
        "pageName": "home",
        "pageId": 1,
        "sections": [
          {
            "sectionId": "a0us1n",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              {
                fieldId: "vas2fp",
                fieldType: "multi-campaign"
              }
            ]
          }
        ]
      },
      { // Moneyback2022 campaign
        "pageName": "Moneyback2022",
        "pageId": 28972,
        "isPublic": true,
        "sections": [
          {
            "sectionId": "orbg8s",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              {
                "fieldType": "refresh-token",
                "fieldId": "ij3433"
              },
              {
                fieldId: "dte-003",
                fieldType: "dataLayer-event",
                properties: {
                  eventName: "PageView",
                  fbEvent: "PageView"
                }
              },
              {
                "fieldType": "key-visual",
                "fieldId": "296eg1",
                "properties": {
                  "grid": {
                    "columns": "12"
                  },
                  "styles": {
                    "margin": '2% 0 0 0',
                    "padding": '0'
                  },
                  "noContainer": false,
                  "addRow": true,
                  "desktopImageUrl": "/assets/campaigns/Moneyback2022/key-visual.png",
                  "mobileImageUrl": "/assets/campaigns/Moneyback2022/key-visual.png"
                }
              },
              {
                "fieldType": "participa",
                "fieldId": "acsh315",
                "properties": {
                  "grid": {
                    "columns": "12"
                  },
                  "color": "#009CA6",
                  "buttonClass": "btn-cyan",
                  "nextPage": "Moneyback2022/InscrieBonul",
                  "campaign": "Moneyback2022",
                  "steps": [
                    {
                      "title": "Pasul 1",
                      "text": "Cumpara pasta de dinti Colgate Max White",
                      "image": "select"
                    },
                    {
                      "title": "Pasul 2",
                      "text": "Incarca bonul fiscal",
                      "image": "receipt"
                    },
                    {
                      "title": "Pasul 3",
                      "text": "Inregistreaza-te",
                      "image": "register"
                    },
                    {
                      "title": "Pasul 4",
                      "text": "Primeste banii inapoi!",
                      "image": "reward"
                    }
                  ]
                }
              }
            ]
          }
        ]
      },
      { // Upload receipt
        "pageName": "Moneyback2022/InscrieBonul",
        "pageId": 22345,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "sectionId": "fu30zq",
            "fields": [
              {
                "fieldType": "step-counter",
                "fieldId": "tj4j49",
                "properties": {
                  "activeIndex": 1,
                  "colorSchema": "#00B6C2",
                  "stepShadow": "#BEEAED",
                  "startGradient": "#BEEAED",
                  "endGradient": "#00B6C2",
                  "completedGradient": "linear-gradient(57.51deg, #00B6C2 3.98%, #57D2DA 95.58%), #ffffff",
                  "steps": [
                    {
                      "title": "Cumpara pasta de dinti Colgate Max White",
                      "page": "PizBuinCarrefourJune2022/InscrieBonul"
                    },
                    {
                      "title": "Incarca bonul fiscal",
                      "page": "PizBuinCarrefourJune2022/Inregistreaza"
                    },
                    {
                      "title": "Inregistreaza-te",
                      "page": "PizBuinCarrefourJune2022/Inregistreaza"
                    },
                    {
                      "title": "Primeste banii inapoi!",
                      "page": "PizBuinCarrefourJune2022/Inregistreaza"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1 style='color: #141414'>Incarca bonul fiscal/factura</h1>"
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "La acest pas, te rugam sa introduci dovada achizitionarii Colgate Max White",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '24px;',
                    "color": "#2E2E2E"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basg325",
                "properties": {
                  "text": "Te rugam sa faci o poza a intregului/intregii bon fiscal/facturi sau sa incarci un pdf al facturii",
                  "grid": {
                    "marginBottom": "40px"
                  },
                  styles: {
                    "font-weight": '400;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '16px;',
                    "line-height": "26px;",
                    "color": "#474747"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 0,
                    "justifyContent": "center",
                    "maxWidth": "1230px"
                  },
                  "fields": [
                    {
                      "fieldType": "receipt-processor",
                      "fieldId": "klvakj",
                      "properties": {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca bonul fiscal/factura.</span>.<br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        "colorSchema": "#00B6C2",
                        "fileUploadColor": "rgba(0, 0, 0, 0.5)",
                        "textColor": "#00291C",
                        "borderColor": "#009CA6",
                        "buttonClass": "btn-cyan-secondary",
                        "grid": {
                          "columns": 5,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "successAction": {
                          "fn": "goToPage",
                          "params": "Moneyback2022/Inregistreaza"
                        },
                        "campaignId": "colgate-moneyback",
                        "phrases": [
                          "Chitanta dvs. este acum incarcata si procesata.",
                          "Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.",
                          "Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou."
                        ],
                        "cornerDetectionPhrases": [
                          "Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.",
                          "Te rugam sa potrivesti bonul in cadran.",
                          "Puteti sterge informatii private cu instrumentul de stergere."
                        ],
                        "eraseColor": "#fff",
                        "eraseSize": 12,
                        "cropColor": "#FFAD70",
                        "cropBackground": "rgba(0,0,0,0.6)",
                        "cropTitle": "Decupeaza",
                        "eraseTitle": "Acopera",
                        "dragTitle": "Deplaseaza imaginea",
                        "zoomInTitle": "Mareste",
                        "zoomOutTitle": "Micsoreaza",
                        "selectImageTitle": "Select an Image",
                        "selectAnotherTitle": "Select Another",
                        "controlsBackground": "#009CA6",
                        "backgroundColorBtn": "black"
                      }
                    },
                    {
                      "fieldType": "empty-bucket",
                      "properties": {
                        "grid": {
                          "columns": 7
                        },
                        "fields": [
                          {
                            "fieldType": "receipt-information",
                            "fieldId": "5mq1p6",
                            "properties": {
                              "grid": {
                                "alignItems": "center",
                                "justifyContent": "center",
                                "columns": "12"
                              },
                              "styles": {
                                "text-align": "left",
                                "background": "#FF6905"
                              },
                              "color": "#009CA6",
                              "textColor": "#2E2E2E",
                              "descriptionTextColor":"#E96161",
                              "descriptionText": "Nu se accepta bonuri sau facturi pliate/indoite sau scanate",
                              "receiptImage": "receipt17",
                              "steps": [
                                {
                                  "text": "Nume Retailer/ Magazin",
                                  "label": "A"
                                },
                                {
                                  "text": "Produsele care intra in promotie si pretul lor",
                                  "label": "B"
                                },
                                {
                                  "text": "Suma totala a bonului/facturii in LEI/RON",
                                  "label": "C"
                                },
                                {
                                  "text": "Nr bonului fiscal/facturii",
                                  "label": "D"
                                },
                                {
                                  "text": "Data si ora de pe bon sau de pe factura",
                                  "label": "E"
                                }
                              ]
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "bsbsd35",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "receipt-image-information"
              }
            ]
          },
          {
            "sectionId": "hmgwhl",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "40px"
            },
            "container": true,
            "buttonsWrap": true,
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm1",
                "properties": {
                  "grid": {
                    "columns": "0"
                  },
                  "addClass": "btn-link",
                  "text": "Inapoi",
                  "disabled": false,
                  "styles": {
                    "position": "absolute;",
                    "left": 0
                  },
                  "action": {
                    "fn": "goToPage",
                    "params": "Moneyback2022"
                  }
                }
              },
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "Continua",
                  "addClass": "btn-cyan",
                  "shouldCheckCrop": true,
                  "requires": ["klvakj"],
                  "action": {
                    "fn": "sendReceipt",
                    "params": ""
                  }
                }
              }
            ]
          }
        ]
      },
      { // Register form
        "pageName": "Moneyback2022/Inregistreaza",
        "pageId": 634553232,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12
            },
            "container": true,
            "fields": [
              {
                "fieldType": "step-counter",
                "fieldId": "tj4j49",
                "properties": {
                  "activeIndex": 2,
                  "colorSchema": "#00B6C2",
                  "stepShadow": "#BEEAED",
                  "startGradient": "#BEEAED",
                  "endGradient": "#00B6C2",
                  "completedGradient": "linear-gradient(57.51deg, #00B6C2 3.98%, #57D2DA 95.58%), #ffffff",
                  "steps": [
                    {
                      "title": "Cumpara pasta de dinti Colgate Max White",
                      "page": "PizBuinCarrefourJune2022/InscrieBonul"
                    },
                    {
                      "title": "Incarca bonul fiscal",
                      "page": "PizBuinCarrefourJune2022/Inregistreaza"
                    },
                    {
                      "title": "Inregistreaza-te",
                      "page": "PizBuinCarrefourJune2022/Inregistreaza"
                    },
                    {
                      "title": "Primeste banii inapoi!",
                      "page": "PizBuinCarrefourJune2022/Inregistreaza"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "fckzg7",
                "properties": {
                  "text": "<h1 style='color: #141414'>Formular de inscriere</h1>"
                }
              }
            ]
          },
          {
            "sectionId": "ci88zt",
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 4,
              "marginTop": "40px"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "form-component",
                "fieldId": "j765n4b",
                "properties": {
                  "styles": {
                    "margin": "0",
                    "justifyContent": "center",
                    "--maxWidth": "545px",
                    "--backgroundColor": "#F1FAFB"
                  },
                  "grid": {
                    "alignItems": "center",
                    "columns": "0",
                    "justifyContent": "center"
                  },
                  "requires": [
                    "1"
                  ],
                  "successAction": {
                    "fn": "goToPage",
                    "params": "Moneyback2022/Multumim"
                  },
                  "endpoint": "/register",
                  "ibanEndpoint": "/submitIBANv2",
                  "fields": [
                    {
                      "fieldId": "b4baqs",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "surname",
                        "autocomplete": "no",
                        "label": "Prenume",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "30px",
                          "border-color": "#69CBD2",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "gofije",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "name",
                        "autocomplete": "no",
                        "label": "Nume",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#69CBD2",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "h7kzf9",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "email",
                        "label": "E-mail",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|email",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#69CBD2",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "vake42c",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "mobile",
                        "label": "Numar de telefon",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|phoneNumber",
                        "grid": {
                          "columns": 12
                        },
                        "autocomplete": "nope",
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#69CBD2",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "vake43c",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "iban",
                        "label": "IBAN",
                        "placeholder": "",
                        "mask": "RO## AAAA NNNN NNNN NNNN NNNN",                        
                        "upperCase": true,
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|iban",
                        "grid": {
                          "columns": 12
                        },
                        "autocomplete": "nope",
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#69CBD2",
                          "border-radius": "8px"
                        }
                      }
                    },
                    { 
                      "fieldId": "v1nf34",
                      "fieldType": "select-input",
                      "properties": {
                        "name": "bank",
                        "label": "Bancă",
                        "placeholder": "Bancă",
                        "text": "",
                        "validation": "required",
                        "options": [
                          { "text": "Alpha Bank", "value": "BUCU" },
                          { "text": 'Banca Romaneasca', "value": 'BRMA' },
                          { "text": 'Banca Transilvania', "value": 'BTRL' },
                          { "text": 'BCR', "value": 'RNCB' },
                          { "text": 'BRCI', "value": 'MIND' },
                          { "text": 'BRD', "value": 'BRDE' },
                          { "text": 'CEC', "value": 'CECE' },
                          { "text": 'Credit Agricole', "value": 'BSEA' },
                          { "text": 'Credit Europe Bank', "value": 'FNNB' },
                          { "text": 'Eximbank', "value": 'EXIM' },
                          { "text": 'FirstBank', "value": 'PIRB' },
                          { "text": 'Garanti Bank', "value": "UGBI" },
                          { "text": 'Idea Bank', "value": 'ROIN' },
                          { "text": 'ING', "value": 'INGB' },
                          { "text": 'Intesa Sanpaolo Bank', "value": 'WBAN' },
                          { "text": 'Libra Bank', "value": 'BREL' },
                          { "text": 'Orange Money', "value": 'ORMF' },
                          { "text": 'OTP Bank', "value": 'OTPV' },
                          { "text": 'Patria Bank', "value": 'CARP' },
                          { "text": 'ProCredit Bank', "value": 'MIRO' },
                          { "text": 'Raiffeisen Bank', "value": 'RZBR' },
                          { "text": 'TBI Bank', "value": 'TBIB' },
                          { "text": 'UniCredit Tiriac Bank', "value": 'BACX' },
                          { "text": 'Vista Bank', "value": 'EGNA' },
                          { "text": "Altele", "value": "AAAA" }
                        ],
                        "selectedValue": "",
                        "grid": {
                          "columns": "12"
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#69CBD2 !important",
                          "border-radius": "8px !important"
                        }
                      }
                    },
                    {
                      "fieldId": "gofij1",
                      "fieldType": "text-area",
                      "properties": {
                        "name": "returnReason",
                        "autocomplete": "no",
                        "label": "De ce doresti sa returnezi produsul?",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|min:20|max:200",
                        "maxlength": 201,
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#69CBD2",
                          "border-radius": "8px",
                          "min-height": "100px",
                          "max-width": "435px"
                        }
                      }
                    },
                    {
                      "fieldId": "ko3h1sz",
                      "fieldType": "paragraph",
                      "properties": {
                        "text": "<b>Atentie!</b> In cazul introducerii unei adrese de e-mail gresite, daca esti declarat castigator, nu vei primi premiul castigat, conform Articolelor 4.3, 4.4, 8.7 si 8.8 din Regulamentul campaniei.",
                        "grid": {
                          "columns": "12",
                          "marginTop": "50px"
                        },
                        "classes": ['disclaimer'],
                        "styles":{
                          "color": "#2E2E2E !important"
                        }
                      }
                    },
                    {
                      "fieldId": "wgc3j7",
                      "fieldType": "checkbox",
                      "properties": {
                        "name": "terms",
                        "validation": {
                          "required": {
                            "allowFalse": false
                          }
                        },
                        "validationName": "Termenii si conditiile sunt necesare",
                        "grid": {
                          "columns": "12",
                          "paddingTop": "10px"
                        },
                        "styles": {
                          "margin-top": "30px",
                          "--color": "rgba(5, 14, 35, 1)",
                          "--border": "1px solid #FFC499",
                          "background-color":"border: #FFC499",
                          "--checkedCheckbox": "url(/assets/icons/form/checked_checkbox.svg)",
                          "--uncheckedCheckbox": "url(/assets/icons/form/unchecked_checkbox.svg)"
                        },
                        "label": `Confirm ca am peste 18 ani. Confirm <a href="/files/Moneyback2022Regulament.pdf" target="_blank"><u>termenii si conditiile</u></a> si <a href="https://www.colgatepalmolive.ro/legal-privacy-policy/privacy-policy" target="_blank"><u>politica de confidentialitate</u></a></div>.`
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "yh453gg4",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "120px"
            },
            "container": true,
            "buttonsWrap": true,
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm1",
                "properties": {
                  "grid": {
                    "columns": "0"
                  },
                  "addClass": "btn-link",
                  "text": "Inapoi",
                  "disabled": false,
                  "styles": {
                    "position": "absolute;",
                    "left": 0
                  },
                  "action": {
                    "fn": "goToPage",
                    "params": "Moneyback2022/InscrieBonul"
                  }
                }
              },
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "TRIMITE",
                  "disabled": false,
                  "addClass": "btn-cyan",
                  "action": {
                    "fn": "sendForm",
                    "params": "j765n4b"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Winner form page
        "pageName": "Moneyback2022/WinnerPage",
        "isPublic": true,
        "pageId": 634553,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "headerWrap": true,
            "sectionId": "basb782",
            "fields": [
              {
                "fieldType": "query-string-to-state",
                "fieldId": "vasv24",
                properties: {
                  variables: [
                    {
                      query: "customerToken",
                      state: "customerToken"
                    }
                  ]
                }
              },
              {
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "receiptToken",
                      state: "receiptToken"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1 style='color: #141414'>Formular pentru Castigator</h1>"
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Completeaza-ti adresa in formularul de mai jos pentru a-ti putea trimite premiul",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '20px;',
                    "color": "#0E1B17"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "ci88zt",
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 4,
              "marginTop": "50px"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "form-component",
                "fieldId": "j765n4b",
                "properties": {
                  "styles": {
                    "margin": "0",
                    "justifyContent": "center",
                    "--backgroundColor": "#F1FAFB"
                  },
                  "grid": {
                    "alignItems": "center",
                    "columns": "0",
                    "justifyContent": "center"
                  },
                  "requires": [
                    "1"
                  ],
                  "successAction": {
                    "fn": "goToPage",
                    "params": "Moneyback2022/WinnerThankYou"
                  },
                  "endpoint": "/winnerRegister",
                  "fields": [
                    {
                      "fieldId": "b4baqs",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "surname",
                        "autocomplete": "no",
                        "label": "Prenume",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "30px",
                          "border-color": "#69CBD2",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "gofije",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "name",
                        "autocomplete": "no",
                        "label": "Nume",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#69CBD2",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "h7kzf9",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "email",
                        "label": "E-mail",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|email",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#69CBD2",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "vake42c",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "mobile",
                        "label": "Numar de telefon",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|phoneNumber",
                        "grid": {
                          "columns": 12
                        },
                        "autocomplete": "nope",
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#5AA790",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "h7kzf8",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "address",
                        "label": "Adresa",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "requiredAdress|adress",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#69CBD2",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "ko3h1sz",
                      "fieldType": "paragraph",
                      "properties": {
                        "text": "*strada, numar, bloc, scara, apartament",
                        "grid": {
                          "columns": "12",
                          "marginTop": "20px;",
                          "marginBottom": "20px"
                        },
                        "classes": ['disclaimer'],
                        "styles":{
                          "color": "rgba(0, 41, 28, 1) !important"
                        }
                      }
                    }
                  ],
                  "extraFields": [
                    {
                      "fieldId": "bdsb632",
                      "fieldType": "select-input-county",
                      "properties": {
                        "name": "judet",
                        "label": "Judet",
                        "placeholder": "Judet",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "requiredJudet",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "30px",
                          "border-color": "#69CBD2",
                          "border-radius": "8px !important"
                        },
                        "autocomplete": "nope"
                      }
                    },
                    {
                      "fieldId": "bask257",
                      "fieldType": "select-input-city",
                      "properties": {
                        "name": "localitate",
                        "label": "Localitate",
                        "placeholder": "Localitate",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "requiredLocal",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#69CBD2",
                          "border-radius": "8px !important"
                        },
                        "autocomplete": "nope"
                      }
                    },
                    {
                      "fieldId": "acasg235",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "postal",
                        "label": "Cod postal",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "integer|length:6",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#69CBD2",
                          "border-radius": "8px"
                        },
                        "autocomplete": "nope",
                        "disablePaste": true
                      }
                    },
                    {
                      "fieldId": "bsdy4362",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "cnp",
                        "autocomplete": "no",
                        "label": "CNP",
                        "placeholder": "",
                        "text": "",
                        "validation": "required|integer|length:13",
                        "color": "#2E2E2E",
                        "grid": {
                          "alignItems": "center;",
                          "justifyContent": "center;",
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#69CBD2",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "bsadbsd325",
                      "fieldType": "checkbox",
                      "properties": {
                        "name": "cnpConfirm",
                        "validation": {
                          "required": {
                            "allowFalse": false
                          }
                        },
                        "validationName": "terms",
                        "grid": {
                          "columns": "12",
                          "paddingTop": "10px"
                        },
                        "styles": {
                          "margin-top": "30px",
                          "--color": "#2E2E2E",
                          "--checkedCheckbox": "url(/assets/icons/form/checked_checkbox.svg)",
                          "--uncheckedCheckbox": "url(/assets/icons/form/unchecked_checkbox.svg)"
                        },
                        "label": `Declar ca acest CNP imi apartine, cunoscand faptul ca orice declaratie falsa este sanctionata conform legii penale romane.`
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "yh453gg4",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "130px"
            },
            "container": true,
            "styles": {
              'justify-content': 'center'
            },
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "TRIMITE",
                  "disabled": false,
                  "addClass": "btn-cyan",
                  "action": {
                    "fn": "sendForm",
                    "params": "j765n4b"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Winner thank you
        "pageName": "Moneyback2022/WinnerThankYou",
        "pageId": 99830,
        "noContainer": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "thank-you-winner",
                "fieldId": "gjd10",
                "properties": {
                  "campaign": "Moneyback2022",
                  "campaignName": "CAMPANIE NATIONALA MAX WHITE ULTRA - MONEY BACK",
                  "haveActivator": false,
                  "textColor": "#141414",
                  "imageStyles":{
                    'margin-bottom': '27%'
                  }
                }
              }
            ]
          }
        ]
      },
      { // Receipt reupload
        "pageName": "Moneyback2022/receipt-reupload",
        "isPublic": true,
        "pageId": 32,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "headerWrap": true,
            "sectionId": "fu30zq",
            "fields": [
              {
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "referenceNumber",
                      state: "formData"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1>Te rugam sa incarci din nou bonul fiscal/factura</h1>"
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "La acest pas, te rugam sa introduci dovada achizitionarii Colgate Max White",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '24px;',
                    "color": "#2E2E2E"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basg325",
                "properties": {
                  "text": "Te rugam sa faci o poza a intregului/intregii bon fiscal/facturi sau sa incarci un PDF al facturii",
                  "grid": {
                    "marginBottom": "40px"
                  },
                  styles: {
                    "font-weight": '400;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '16px;',
                    "line-height": "30px;",
                    "color": "#2E2E2E"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 0,
                    "justifyContent": "center",
                    "maxWidth": "1230px"
                  },
                  "fields": [
                    {
                      "fieldType": "receipt-processor",
                      "fieldId": "klvakj",
                      "properties": {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca bonul fiscal/factura.</span>.<br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        "colorSchema": "#57D2DA",
                        "fileUploadColor": "rgba(0, 0, 0, 0.5)",
                        "textColor": "#2E2E2E",
                        "borderColor": "#009CA6",
                        "buttonClass": "btn-cyan-secondary",
                        "grid": {
                          "columns": 5,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "successAction": {
                          "fn": "goToPage",
                          "params": "Moneyback2022/Multumesc"
                        },
                        "campaignId": "colgate-moneyback",
                        "phrases": [
                          "Chitanta dvs. este acum incarcata si procesata.",
                          "Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.",
                          "Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou."
                        ],
                        "cornerDetectionPhrases": [
                          "Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.",
                          "Te rugam sa potrivesti bonul in cadran.",
                          "Puteti sterge informatii private cu instrumentul de stergere."
                        ],
                        "eraseColor": "#ffffff",
                        "eraseSize": 12,
                        "cropColor": "#FF6905",
                        "cropBackground": "rgba(0,0,0,0.6)",
                        "cropTitle": "Decupeaza",
                        "eraseTitle": "Acopera",
                        "dragTitle": "Deplaseaza imaginea",
                        "zoomInTitle": "Mareste",
                        "zoomOutTitle": "Micsoreaza",
                        "selectImageTitle": "Select an Image",
                        "selectAnotherTitle": "Select Another",
                        "controlsBackground": "#009CA6",
                        "backgroundColorBtn": "black",
                        "reUpload": true,
                        "tokenName": "token"
                      }
                    },
                    {
                      "fieldType": "empty-bucket",
                      "properties": {
                        "grid": {
                          "columns": 7
                        },
                        "fields": [
                          {
                            "fieldType": "receipt-information",
                            "fieldId": "5mq1p6",
                            "properties": {
                              "grid": {
                                "alignItems": "center",
                                "justifyContent": "center",
                                "columns": "12"
                              },
                              "styles": {
                                "text-align": "left"
                              },
                              "color": "#009CA6",
                              "textColor": "#2E2E2E",
                              "descriptionTextColor":"#E96161",
                              "descriptionText": "Nu se accepta bonuri sau facturi pliate/indoite sau scanate",
                              "receiptImage": "receipt17",
                              "steps": [
                                {
                                  "text": "Nume magazin",
                                  "label": "A"
                                },
                                {
                                  "text": "Produsele participante la promotie si pretul lor",
                                  "label": "B"
                                },
                                {
                                  "text": "Suma totala a bonului fiscal/facturii in LEI",
                                  "label": "C"
                                },
                                {
                                  "text": "Nr. bonului fiscal/facturii",
                                  "label": "D"
                                },
                                {
                                  "text": "Data si ora de pe bonul fiscal sau factura",
                                  "label": "E"
                                }
                              ]
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "bsbsd35",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "receipt-image-information"
              }
            ]
          },
          {
            "sectionId": "hmgwhl",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "40px"
            },
            "container": true,
            "styles": {
              'justify-content': 'center'
            },
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "Trimite",
                  "addClass": "btn-cyan",
                  "shouldCheckCrop": true,
                  "requires": ["klvakj"],
                  "action": {
                    "fn": "sendReceipt",
                    "params": ""
                  }
                }
              }
            ]
          }
        ]
      },
      { // Product reupload
        "pageName": "Moneyback2022/product-reupload",
        "isPublic": true,
        "pageId": 1282452,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "headerWrap": true,
            "sectionId": "fu30zq",
            "fields": [
              {
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "referenceNumber",
                      state: "formData"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1 style='color: #141414'>Incarca o poza a produsului</h1>"
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basv352",
                "properties": {
                  "text": "Incarca o poza cu produsele participante in campanie",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '20px;',
                    "color": "#2E2E2E"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basg325",
                "properties": {
                  "text": "Doar fisiere JPG, si PNG sunt acceptate. Fisierul poate avea maxim 16MB.",
                  "grid": {
                    "marginBottom": "40px"
                  },
                  styles: {
                    "font-weight": '400;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '14px;',
                    "line-height": "20px;",
                    "color": "#474747"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 0,
                    "justifyContent": "center",
                    "maxWidth": "1230px"
                  },
                  "fields": [
                    {
                      "fieldType": "product-upload",
                      "fieldId": "ase123v",
                      "properties": {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca poza</span><br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Fisierul poate avea maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        "colorSchema": "#57D2DA",
                        "borderColor": "#009CA6",
                        "buttonClass": "btn-cyan-secondary",
                        "textColor": "#2E2E2E",
                        "grid": {
                          "columns": 5,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "endpoint": "/uploadProductPhoto",
                        "successAction": {
                          "fn": "goToPage",
                          "params": "Moneyback2022/Multumesc"
                        },
                        "phrases": [
                          "Chitanta dvs. este acum incarcata si procesata.",
                          "Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.",
                          "Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou."
                        ],
                        "cornerDetectionPhrases": [
                          "Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.",
                          "Te rugam sa potrivesti bonul in cadran.",
                          "Puteti sterge informatii private cu instrumentul de stergere."
                        ],
                        "reUpload": true
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "hmgwhl",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "marginTop": "60px",
              "marginBottom": "30px"
            },
            "container": true,
            "styles": {
              'justify-content': 'center'
            },
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "Trimite",
                  "addClass": "btn-cyan",
                  "shouldCheckCrop": false,
                  "requires": ["ase123v"],
                  "action": {
                    "fn": "sendProductPhotos",
                    "params": ""
                  }
                }
              }
            ]
          }
        ]
      },
      { // Thank you
        "pageName": "Moneyback2022/Multumim",
        "pageId": 99800,
        "noContainer": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "step-counter",
                "fieldId": "tj4j49",
                "properties": {
                  "activeIndex": 3,
                  "colorSchema": "#00B6C2",
                  "stepShadow": "#BEEAED",
                  "startGradient": "#BEEAED",
                  "endGradient": "#00B6C2",
                  "completedGradient": "linear-gradient(57.51deg, #00B6C2 3.98%, #57D2DA 95.58%), #ffffff",
                  "steps": [
                    {
                      "title": "Cumpara pasta de dinti Colgate Max White",
                      "page": "PizBuinCarrefourJune2022/InscrieBonul"
                    },
                    {
                      "title": "Incarca bonul fiscal",
                      "page": "PizBuinCarrefourJune2022/Inregistreaza"
                    },
                    {
                      "title": "Inregistreaza-te",
                      "page": "PizBuinCarrefourJune2022/Inregistreaza"
                    },
                    {
                      "title": "Primeste banii inapoi!",
                      "page": "PizBuinCarrefourJune2022/Inregistreaza"
                    }
                  ]
                }
              },
              {
                "fieldType": "thank-you",
                "fieldId": "gjd10",
                "properties": {
                  "campaign": "Moneyback2022",
                  "campaignName": "CAMPANIE NATIONALA MAX WHITE ULTRA - MONEY BACK",
                  "haveActivator": false,
                  "borderColor": "#57D2DA",
                  "textColor": "#141414",
                  "referenceColor": "#009CA6",
                  "imageStyles":{
                    'margin-top': '15%'
                  }
                }
              }
            ]
          }
        ]
      },
      { // Thank you after reupload
        "pageName": "Moneyback2022/Multumesc",
        "pageId": 99801,
        "noContainer": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "thank-you",
                "fieldId": "gjd10",
                "properties": {
                  "campaign": "Moneyback2022",
                  "campaignName": "CAMPANIE NATIONALA MAX WHITE ULTRA - MONEY BACK",
                  "haveActivator": false,
                  "borderColor": "#57D2DA",
                  "textColor": "#141414",
                  "referenceColor": "#009CA6",
                  "imageStyles":{
                    'margin-top': '17%'
                  }
                }
              }
            ]
          }
        ]
      },
      { // Error page
        "pageName": "error-page",
        "pageId": 10424,
        isPublic: true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12
            },
            "container": true,
            fields: [
              {
                "fieldType": "error-page",
                "fieldId": "gjd10",
                "properties": {
                  "grid": {
                    "columns": "12"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Faq
        "pageName": "Moneyback2022/IntrebariFrecvente",
        "isPublic": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12,
              "marginBottom": "50px"
            },
            "fields": [
              {
                "fieldType": "text-list",
                "fieldId": "a6prst",
                "properties": {
                  "colorSchema": "#2E2E2E",
                  "title": "Intrebari frecvente",
                  "items": [
                    { // 1
                      title: `Ce condiții trebuie să îndeplinesc pentru a participa la „CAMPANIA NATIONALA MAX WHITE ULTRA - MONEY BACK”?`,
                      text: `
                      <ul>
                          <li>Vârsta minimă: Trebuie să ai cel puțin 18 ani</li>
                          <li>Domiciliul: Trebuie să ai domiciliul în România.</li>
                          <li>Detaliile contului: Trebuie să introduci un IBAN românesc.</li>
                          <li>Adresa de e-mail: Poți participa doar cu propria adresă de e-mail.</li>
                      </ul>
                      <div style="margin-top: 10px">Notă: IBAN-ul și adresa de e-mail pot fi combinate o singură dată pentru întreaga perioadă a
                      campaniei.</div>`
                    },
                    { // 2
                      title: `Cum pot participa la „CAMPANIA NATIONALA MAX WHITE ULTRA - MONEY BACK”?`,
                      text: `Poți participa doar online, prin intermediul site-ului campanie <a href="/Moneyback2022" target="_blank">promocolgatepalmolive.ro</a>. Din păcate, nu este posibilă participarea prin poștă. Procesul poate fi descris după cum urmează:
                      <ul style="margin-top: 10px; margin-bottom: 10px">
                          <li>Fotografiază și încarcă bonul fiscal/factura;</li>
                      </ul>
                      Doar în cazul solicitării ulterioare, trebuie să încarci o fotografie a codului de bare al produsului tău Colgate. (Trebuie să te asiguri că este vizibil codul de bare.) În mod suplimentar, bonul fiscal/factura trebuie să apară clar/ă și lizibil/ă pe fotografia cu produsul.
                      <ul style="margin-top: 10px;">
                          <li>Introdu adresa de e-mail și celelalte informații personale</li>
                          <li>Acceptă termenii de participare și protecția datelor personale.</li>
                          <li>Vei primi un e-mail cu instrucțiuni privitoare la adresa unde trebuie să returnezi produsul.</li>
                          <li>Trimite produsul. De îndată ce vom primi produsul, vei fi informat prin e-mai și vei primi rambursul in termen de 4 săptămâni.</li>
                      </ul>
                      <div style="margin-top: 10px">Notă: Nu este posibilă utilizarea unor adrese de e-mail diferite (conturi de utilizator) pentru aceeași
                      persoană.</div>`
                    },
                    { // 3
                      title: `Pe cine trebuie să contactez dacă am o întrebare privitoare la „CAMPANIA NATIONALA MAX WHITE ULTRA - MONEY BACK”?`,
                      text: `Te rugăm să contactezi suportul campaniei la adresa <a href="mailto:suport@promocolgatepalmolive.ro">suport@promocolgatepalmolive.ro</a>`
                    },
                    { // 4
                      title: `Ce produse trebuie să cumpăr pentru a participa la „CAMPANIA NATIONALA MAX WHITE ULTRA - MONEY BACK”?`,
                      text: `Produsele următoare fac parte din „CAMPANIA NATIONALA MAX WHITE ULTRA - MONEY BACK”:
                      <ul style="margin-top: 10px;">
                          <li>Pasta de dinti Colgate Max White Ultra Active Foam 50ml</li>
                          <li>Pasta de dinti Colgate Max White Ultra Freshness Pearls 50ml</li>
                      </ul>
                      `
                    },
                    { // 5
                      title: `De unde pot cumpăra produsele participante la „CAMPANIA NATIONALA MAX WHITE ULTRA - MONEY BACK”?`,
                      text: `Poți cumpăra toate produsele participante la campanie din din toate magazinele comerciale înregistrate din România, inclusiv magazinele fizice, cât și online.`
                    },
                    { // 6
                      title: `CDacă am folosit un voucher sau am beneficiat de reduceri suplimentare din valoarea produselor, ce ramburs voi primi?`,
                      text: `Orice reducere aplicată produselor participante sau utilizarea voucherelor de cumpărături, care este marcată pe bonul fiscal/factură, va fi scăzută din suma totala rambursată. Reducerile sau
                      voucherele nu pot fi rambursate sub nicio formă printr-o sumă de bani.`
                    },
                    { // 7
                      title: `Care este suma rambursată?`,
                      text: `Vei primi un ramburs de 100% din prețul efectiv plătit pentru produsul participant pe care dorești să-l
                      returnezi.`
                    },
                    { // 8
                      title: 'Când pot participa la „CAMPANIA NATIONALA MAX WHITE ULTRA - MONEY BACK”?',
                      text: `Perioada de achiziție a produsului promoțional este cuprinsă între 01.07.2022 și, inclusiv,
                      31.08.2022.Înregistrarea pentru participarea la campania trebuie realizată în termen de 10 de zile
                      după achiziționarea. Termenul-limită pentru trimiterea formularului de înregistrare online și
                      încărcarea bonului fiscal/facturii de achiziție este 31.08.2022. După ce vei primi e-mailul de
                      confirmare, trebuie să returnezi produsul în termen de 10 zile.`
                    },
                    { // 9
                      title: 'Cât de des pot participa la „CAMPANIA NATIONALA MAX WHITE ULTRA - MONEY BACK”?',
                      text: `Fiecare persoană (cont de utilizator: IBAN și adresă de e-mail) poate participa la campanie cu un
                      număr maxim de un bon fiscal/factură.`
                    },
                    { // 10
                      title: 'Cu câte produse pot participa la „CAMPANIA NATIONALA MAX WHITE ULTRA - MONEY BACK”?',
                      text: `Rambursările pot fi eliberate pentru un produs participant per persoană.`
                    },
                    { // 11
                      title: `Eu și partenerul/a meu/a avem un cont IBAN comun. Putem participa amândoi la „CAMPANIA NATIONALA MAX WHITE ULTRA - MONEY BACK” cu acest cont în mod separat?`,
                      text: `Fiecare IBAN poate fi folosit de către un singur utilizator pentru întreaga perioadă promoțională
                      (într-o combinație fixă cu adresa de e-mail și numărul de telefon). Utilizarea în comun cu alt
                      participant nu este posibilă, indiferent de orice legătură personală.`
                    },
                    { // 12
                        title: 'Când mă pot aștepta la ramburs?',
                        text: `După recepționarea produsului trimis de către tine, suma rambursată va fi transferată în contul tău
                        bancar (IBAN) menționat în maxim 4 săptămâni.`
                    },
                    { // 13
                      title: 'Cine va fi responsabil pentru orice costuri legate de transferul rambursului?',
                      text: `Pentru „CAMPANIA NATIONALA MAX WHITE ULTRA - MONEY BACK”, organizatorul nu este
                      responsabil de niciun cost asociat cu transferul rambursului. Fiecare participant trebuie să se
                      informeze înainte de a participa la campanie în ceea ce privește posibilele cheltuieli privitoare la
                      ramburs. Fiecare bancă are posibilitatea de a impune taxe în conformitate cu politicile sale interne,
                      iar organizatorul Campaniei nu are control sau informații despre aceste potențiale cheltuieli.
                      Cheltuielile asociate cu transferul de bani pot varia de la o bancă la alta. În cazul tău, le poți găsi
                      scrise în contractul încheiat cu banca și pe care l-ai semnat când ai deschis contul tău bancar cu
                      IBAN.`
                    },
                    { // 14
                      title: 'Cât timp trebuie să păstrez bonul fiscal/factura?',
                      text: `Trebuie să păstrezi bonul fiscal/factura până în momentul în care primești rambursul.`
                    },
                    { // 15
                      title: 'Bonul meu fiscal conține mai mult de un produs promoțional Colgate. Pot două sau mai multe persoane să folosească bonul fiscal/factura?',
                      text: `În principiu, un bon fiscal/factură poate participa o singură dată la „CAMPANIA NATIONALA MAX
                      WHITE ULTRA - MONEY BACK”. Produsele promoționale enumerate pe bonul fiscal/factură nu pot fi
                      luate în considerare, iar un produs promoțional nu poate fi transferat altei persoane.`
                    },
                    { // 16
                      title: 'Nu am primit un e-mail de confirmare după terminarea procesului de înscriere. Ce trebuie să fac?',
                      text: `După ce te-ai înregistrat, vei primi un e-mail de confirmare cu un număr de referință format din 10
                      caractere alfanumerice. Te rugăm să verifici și dosarul de SPAM și JUNK. Dacă nu ai primit un număr
                      de referință format din 10 caractere alfanumerice, te rugăm să participi din nou prin intermediul
                      site-ului pentru promoții <a href="/Moneyback2022">promocolgatepalmolive.ro</a>`
                    },
                    { // 17
                      title: 'Când parcurg procesul de înscriere pentru rambursare, acesta se oprește la un moment dat. Ce trebuie să fac?',
                      text: `Dacă te încurci în timpul procesului de înscriere din motive tehnice, îți recomandăm – dacă este
                      posibil – să utilizezi un alt dispozitiv. De exemplu, treci de pe telefonul mobil pe calculator. Dacă
                      acest lucru nu rezolvă problema, poți încerca să folosești un alt browser. Dacă aceste sfaturi nu te
                      ajută, te rugăm să trimiți un e-mail departamentului nostru de suport: <a href="mailto:suport@promocolgatepalmolive.ro">suport@promocolgatepalmolive.ro</a>. Te rugăm să furnizezi o descriere precisă a problemei în e-mailul
                      tău – o captură de ecran cu pasul la care te blochezi este perfectă. Alte informații utile sunt
                      dispozitivul tău, sistemul de operare și browserul pe care le folosești. Echipa noastră de suport se va
                      strădui să te ajute.`
                    },
                    { // 18
                      title: 'Din ce cauză IBAN-ul meu nu este acceptat pe pagina de promoție?',
                      text: `Asigură-te că introduci IBAN-ul fără spații. Te rugăm să introduci codul țării la început. De
                      asemenea, asigură-te că nu ai introdus în mod accidental un spațiu înainte sau după IBAN.`
                    },
                    { // 19
                        title: 'Nu este mai ușor să primesc rambursul pe cardul Revolut. Este disponibilă opțiunea?',
                        text: `Momentan, singura posibilitate de participare este să furnizezi un IBAN valid. Pentru activările
                        ulterioare, vom lua în considerare și sugestia ta.`
                    },
                    { // 20
                      title: 'Cum îmi pot da seama dacă am reușit să încarc bonul fiscal/factura?',
                      text: `După ce încarci bonul fiscal/factura și introduci informațiile personale, va apărea un mesaj pe
                      ecran care confirmă înscrierea participării tale și îți afișează numărul personal de referință. Vei primi
                      cu promptitudine și un e-mail de confirmare sau respingere a participării pe adresa furnizată.`
                    },
                    { // 21
                      title: 'Cât timp este disponibil departamentul de suport?',
                      text: `Echipa noastră de suport este disponibilă de la începutul campaniei timp de 6 săptămâni după expirarea datei de înregistrare. După 12.10.2022, datele tale vor fi șterse, departamentul de suport
                      va fi închis, iar întrebările tale nu vor mai fi tratate.`
                    },
                    { // 22
                      title: 'Participarea mea a fost confirmată, dar suma rambursată nu este corectă. Cum pot proceda?',
                      text: `Te rugăm să contactezi echipa noastră de suport la 
                      <a href="mailto:suport@promocolgatepalmolive.ro">suport@promocolgatepalmolive.ro</a> și să descrii situația ta în e-mail. Echipa noastră îți va trata cazul.`
                    },
                    { // 23
                      title: 'Cât timp am posibilitatea de a solicita reevaluarea cazului meu?',
                      text: `Singura modalitate în care îți putem reevalua cazul este prin contactarea echipei
                      noastre de suport. Te rugăm să incluzi întotdeauna numărul tău de referință!
                      Această opțiune este disponibilă doar pentru o perioadă limitată de timp. Informațiile tale vor fi
                      șterse după expirarea campaniei de rambursare, așadar procesarea este posibilă numai până la 6
                      săptămâni după termenul-limită, adică până pe 12.10.2022. După aceasta, departamentul de
                      suport va fi închis, iar solicitările tale nu vor mai putea fi tratate.`
                    },
                    { // 24
                      title: 'Bonul fiscal/factura mi-a fost respins/ă deoarece nu sunt lizibile toate informațiile. Ce informații trebuie să fie lizibile?',
                      text: `Magazinul, produsul promoțional Colgate, prețul de achiziție al produsului promoțional Colgate,
                      valoarea totală a bonului fiscal/facturii, numărul bonului fiscal/facturii, TVA-ul vizibil, orice reduceri
                      care pot fi aplicate și ora și data.`
                    },
                    { // 25
                      title: 'De ce mi-a fost respinsă participarea, deși am cumpărat produsul participant?',
                      text: `De exemplu, poate fi din cauza unei erori tehnice sau a faptului că bonul fiscal/factura nu este
                      suficient de lizibil/ă sau este supraexpus/ă.
                      În partea de jos a e-mailului de respingere, vei găsi un buton pentru a încărca bonul fiscal/factura
                      din nou. Dă clic pe buton și vei fi redirecționat automat către încărcarea din nou a bonului
                      fiscal/facturii. Te rugăm să realizezi o fotografie nouă a bonului fiscal/facturii și s-o încarci din nou în
                      termen de 72 de ore. Te rugăm să reții că butonul nu mai este funcțional după 72 de ore.
                      Dacă participarea ta este respinsă din nou, te rugăm să ne contactezi prin intermediul adresei de
                      e-mail de suport, care poate fi găsită și în e-mailul de respingere (<a href="mailto:suport@promocolgatepalmolive.ro">suport@promocolgatepalmolive.ro</a>).`
                    },
                    { // 26
                      title: 'Bonul meu fiscal/factura nu a fost acceptat/ă sau chiar a fost marcat/ă ca fals/ă. Cum este posibil așa ceva?',
                      text: `În cazul în care bonul fiscal/factura este prea neclar/ă sau prea întunecat/ă sau supraexpus/ă
                      astfel, încât informațiile nu mai pot fi lizibile, există posibilitatea să primești un e-mail de respingere, în
                      care bonul fiscal/factura este descris/ă drept un fals sau ești rugat să furnizezi o fotografie mai bună
                      cu <b>Încarcă bonul fiscal/factura</b>. Ajută-ne să îți acceptăm participarea rapid și fără complicații,
                      încărcând o fotografie de bună calitate (nu o scanare!) a bonului tău, care demonstrează că ai un
                      bon fiscal/factură original/ă și în care sunt lizibile toate informațiile necesare. Economisește mult
                      timp și neplăceri atât pentru tine, cât și pentru noi.`
                    },
                    { // 27
                      title: 'Pot trimite bonul fiscal/factura și prin e-mail?',
                      text: `Trimiterea ulterioară a bonului fiscal/facturii poate fi realizată prin butonul de reîncărcare, care se
                      găsește în e-mailul de respingere.
                      Dacă nu ai primit un e-mail de respingere sau de confirmare, atunci este un indiciu că nu ai reușit
                      să te înscrii sau trebuie să parcurgi din nou procesul de rambursare.`
                    },
                    { // 28
                      title: 'Am introdus IBAN-ul greșit la înregistrare. Ce se întâmplă în acest caz?',
                      text: `Dacă ai introdus un IBAN greșit, în care transferul nu poate fi realizat, singura posibilitate este de a-l
                      schimba. Poți contacta departamentul responsabil prin e-mail până pe 12.10.2022: iban-<a href="mailto:suport@promocolgatepalmolive.ro">suport@promocolgatepalmolive.ro</a>. Dacă nu se poate realiza un transfer nici cu acest IBAN, dreptul
                      la ramburs expiră. Te rugăm să te asiguri că IBAN-ul nu a fost deja folosit pentru alt ramburs din
                      „CAMPANIA NATIONALA MAX WHITE ULTRA - MONEY BACK”.`
                    },
                    { // 29
                      title: 'Mi s-a solicitat să mă înscriu prin poștă. Ce înseamnă acest lucru?',
                      text: `Te rugăm să înțelegi că suntem obligați să verificăm cu atenție toate bonurile fiscale/facturile cu
                      privire la autenticitatea lor. Desigur, există posibilitatea ca un bon fiscal/factură să fie respins/ă în
                      mod greșit.
                      În acest caz, îți solicităm să trimiți bonul original către agenția responsabilă prin poștă. Ți se va oferi
                      adresa corespunzătoare prin e-mail. În cazul în care participarea ta este considerată validă, îți vom
                      transfera atât suma rambursată, cât și taxele poștale. Pentru cele de mai sus și alte motive, prin
                      urmare este necesar să păstrezi bonul fiscal/factura până la creditarea rambursului în contul tău.`
                    },
                    { // 30
                      title: 'Ce se întâmplă cu informațiile pe care le-am introdus pe site-ul promoției?',
                      text: `Datele cu caracter personal ale participanților la Campanie vor fi prelucrate de către Organizator, direct sau prin intermediul Împuterniciților, în vederea:
                      <ol>
                        <li>organizării și desfășurării Campaniei;</li>
                        <li>participării la Campanie a persoanelor vizate;</li>
                        <li>desemnării, contactării și validării participanților;</li>
                        <li>rambursării valorii produselor achiziționate conform prezentului Regulament și îndeplinirii
                        obligațiilor fiscale și financiar-contabile ale Organizatorului;</li>
                        <li>soluționării cererilor participanților la Campanie – Operatorul va utiliza aceste date pentru a
                        răspunde eventualelor solicitări, cerințe, reclamații sau oricăror altor întrebări. Mai multe
                        informații găsești aici: <br/>
                        <b><a href="https://www.pg.com/privacy/romanian/%20privacy_statement.shtml" target="_blank">https://www.pg.com/privacy/romanian/ privacy_statement.shtml
                        </a></b></li>
                      </ol>
                      <style>
                        ol{
                          counter-reset: roman;
                        }
                        ol li {
                          list-style: none;
                        }
                        ol > li:before {
                          counter-increment: roman;
                          content:"(" counter(roman, lower-roman)") "
                        }
                      </style>
                      `
                    },
                    { // 31
                      title: 'Am o întrebare generală despre Colgate. Cu cine trebuie să vorbesc?',
                      text: `Dacă ai nevoie de informații suplimentare privitoare la produsele noastre sau dacă ai orice alte
                      întrebări, ne poți contacta prin intermediul linkului de mai jos: <b><a href="https://www.colgatepalmolive.ro/contact-us" target="_blank">https://www.colgatepalmolive.ro/contact-us</a>.</b>`
                    }
                  ],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "8"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Castigatori
        "pageName": "Moneyback2022/castigatori",
        "isPublic": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12,
              "marginBottom": "50px"
            },
            "fields": [
              {
                "fieldType": "text-list",
                "fieldId": "a6prst",
                "properties": {
                  "colorSchema": "#000000",
                  "title": "Castigatori",
                  "ordered": false,
                  "items": [
                    // {
                    //   title: `500 Lei Cora Voucher`,
                    //   text: `
                    //   <ol>
                    //       <li>Stefania Iulia Popescu</li>
                    //       <li>Florin Neculcea</li>
                    //       <li>Cristian Stan</li>
                    //       <li>Aurelia Onea</li>
                    //       <li>Andreea Marin</li>
                    //       <li>Roxana Vasile</li>
                    //       <li>Petronela Stan</li>
                    //       <li>Ionut Cosmin Baescu</li>
                    //       <li>Mirel Danaila</li>
                    //       <li>Nicoleta Platon</li>
                    //   </ol>`
                    // }
                  ],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "8"
                  }
                }
              }
            ]
          }
        ]
      }
    ],
    "header": {
      "fieldType": "navbar",
      "fieldId": "cbx34t",
      "properties": {
        "dataLayer": {
          "GTM": {
            "Sitelocale": "ro-ro",
            "SiteTouchpoint": "",
            "SiteCountry": "RO",
            "SiteBrand": "",
            "SiteLanguage": "RO",
            "SitePlatform": "",
            "SiteEnvironment": "Prod",
            "SiteHost": "CTL",
            "SiteTechnicalAgency": "Justsnap",
            "SiteStatus": "Live",
            "GoogleAnalyticsLocal": "UA-15274544-47",
            "GoogleAnalyticsBrand": "",
            "GoogleAnalyticsSiteSpeedSampleRate": "high",
            "GoogleAnalyticsAllowLinker": "true",
            "GoogleAnalyticsLinkerDomains": "",
            "GoogleAnalyticsEnableOptimizely": "false",
            "GoogleAnalyticsConsentRequired": "true",
            "GoogleAnalyticsOptimizeContainerID": "",
            "GoogleAnalyticsReportingView": "",
            "GoogleReCaptcha": "true",
            "SiteLocalContainer": "",
            "FacebookRemarketingID": "270266680523196",
            "ConsentOverlay": "OneTrust",
            "ConsentOverlayID": "htmllang/7bfbeeed-fe9a-477f-99c7-84ca45614eb3-test",
            "SitePrivacyProtection": "GDPR"
          },
          "GTM_CODE": "GTM-TG4C5LV"
        },
        // "neustar": {
        //   "url": "https://aa.agkn.com/adscores/g.js?sid=9212300878"
        // },
        // "facebookPixel": {
        //   init: "270266680523196"
        // },
        "title": "",
        "color": "#FAF6EE",
        "grid": {
          "columns": 12
        },
        "logo": {
          "imageSource": "/assets/logo.svg",
          "width": 345,
          "alternateText": "Brand Logo",
          "paddingTop": "30px"
        },
        "fields": [
          {
            "fieldId": "ikz8vc",
            "fieldType": "anchor",
            "properties": {
              "text": "Regulament",
              "url": "/files/Moneyback2022Regulament.pdf",
              "target": "_blank",
              "cssClass": "nav-link",
              "styles": {
                "color": "#050E23",
                "fontSize": "18px",
                "fontWeight": "400"
              }
            }
          },
          {
            "fieldId": "slnmdk",
            "fieldType": "anchor",
            "properties": {
              "text": "Intrebari frecvente",
              "url": "/Moneyback2022/IntrebariFrecvente",
              "target": "_blank",
              "cssClass": "nav-link",
              "styles": {
                "color": "#050E23",
                "fontSize": "18px",
                "fontWeight": "400"
              }
            }
          }
        ],
        "showLine": false,
        "meta": [
          { "name": "title", "content": "Protex" },
          {
            "name": "description",
            "content": `Protex`
          },
          {
            "name": "keywords",
            "content": `Protex`
          }
        ]
      }
    },
    "footer": {
      "fieldType": "footer-component",
      "fieldId": "4tfbzz",
      "properties": {
        "links": [
          { "name": "", "link": "" }
        ],
        "supportLinks": [
          { "name": "Confidentialitate", "link": "https://www.jnjconsumer.ro/politica-confidentialitate" }
        ],
        "styles": {
          "color": "#000"
        },
        "fields": [
          {
            "fieldId": "ikz8vc1",
            "fieldType": "anchor",
            "properties": {
              "text": "Termeni si conditii",
              "url": "/files/Moneyback2022Regulament.pdf",
              "target": "_blank",
              "styles": {
                "color": "#40454A"
              }
            }
          },
          {
            "fieldId": "slnmdk2",
            "fieldType": "anchor",
            "properties": {
              "text": " Politica de confidentialitate",
              "url": "https://www.colgatepalmolive.ro/legal-privacy-policy/privacy-policy",
              "target": "_blank",
              "styles": {
                "color": "#40454A"
              }
            }
          }
        ]
      }
    },
    "campaignId": "colgate-moneyback",
    "url": "https://promocolgatepalmolive.ro/",
    "name": "Moneyback2022"
  },
  pageBuilder: {
    selectedField: {
      sectionId: '',
      fieldId: generateUID()
    }
  },
  componentStatus: {},
  modal: {
    type: 'error',
    message: 'An error has occurred',
    isActive: false
  },
  customerToken: '',
  receiptToken: '',
  receiptImage: '',
  campaignId: 'colgate-moneyback',
  formData: new FormData(),
  campaignStartDate: "2023-07-01",
  campaignEndDate: "2023-08-31",
  showNavLinks: false,
  excludedPages: ['home'],
  cities: []
}
